import Modal from 'views/components/UI/Modal'
import {
  Button,
  ButtonBack,
  ButtonContainer,
  Container,
  SubTitle,
  SubTitleContainer,
  Title,
} from '../Users/finish-process-modal/styled'

interface ModalConfirmCopyProcessProps {
  visible: boolean
  processName: string
  onAccept: () => void
  onCancel: () => void
}

const ModalConfirmCopyProcess = (props: ModalConfirmCopyProcessProps) => {
  const { visible, processName, onAccept, onCancel } = props

  return (
    <Modal
      show={visible}
      setShow={() => {}}
      styleContent={{ width: '500px' }}
    >
      <Container>
        <SubTitleContainer>
          <div>
            <Title>Has seleccionado el proceso {processName}.</Title>
            <Title style={{ marginTop: '8px' }}>
              ¿Deseas continuar y copiar la parametrización de este proceso?
            </Title>
            <SubTitle style={{ marginTop: '16px' }}>
              Esta acción reemplazará la parametrización actual del proceso en creación.
            </SubTitle>
          </div>
        </SubTitleContainer>
        <ButtonContainer>
          <ButtonBack onClick={onCancel}>Cancelar</ButtonBack>
          <Button onClick={onAccept}>Continuar</Button>
        </ButtonContainer>
      </Container>
    </Modal>
  )
}

export default ModalConfirmCopyProcess
